export default {
  designer: {
    Name: '设计师名称',
    DesignerIntroduce: '设计师简介',
    PleaseEnterDesignerIntroduce: '请输入设计师简介',
    DesignerNameCannotBeEmpty: '设计师名称不能为空',
    DoNotEnterSpecialSymbols: '请不要输入特殊符号',
    DesignerIntroduceCanNotBeEmpty: '设计师简介不能为空'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/pmc/designer.js